module.exports = __webpack_public_path__ + "static/media/interpreting-certificate.64e08c06.pdf";